import React from 'react';

const VideoClip = (props) => {
    return (
        <video key={props.url}  controls loop>
            <source src={'./content/videos/' + props.url} />
        </video>
    );
}

export default VideoClip;



// WEBPACK FOOTER //
// ./src/components/VideoClip.js